<div *ngIf="loading" class=" container is-fullhd mt-5-desktop mt-2-mobile pb-6">
    <div
            class="container-loading-content is-flex is-justify-content-center is-align-items-center">
        <div class="loading"></div>
    </div>
</div>
<ng-container *ngIf="!loading">
    <div *ngFor="let item of news" class="news-container mt-4">
        <iw-shop-news-template [news]="item"></iw-shop-news-template>
    </div>
    <div class="news-container" *ngIf="news.length == 0">
        <p>Es sind keine Neuigkeiten hinterlegt.</p>
    </div>

</ng-container>

